<template>
  <form action="">
    <b-card
      header="Datos Facturación"
      header-tag="header"
      class="bold-header mt-3"
      header-bg-variant="gray_ligth"
    >
      <div class="form-row">
        <b-form-group
          class="col-md-3"
          id="input-group-1"
          label="Estado"
          label-for="input-1"
        >
          <b-form-select
            id="tipo"
            value-field="tipo"
            text-field="descripcion"
            :options="tipos"
            v-model="usuario.tipo"
            @change="Limpiardatos"
            class="col-md-12 p-2 px-4"
          >
          </b-form-select>
        </b-form-group>

        <b-form-group
          class="col-md-5"
          id="input-group-2"
          label="Numero Documento:"
          label-for="Documento"
        >
          <b-input class="p-2 px-4 btn-xs" v-model="usuario.nroDocumento">
          </b-input>
        </b-form-group>
        <b-form-group
          class="col-md-4 align-middle"
          id="input-group-3"
          label=" Buscar"
          label-for="Documento"
        >
          <span v-if="usuario.tipo === 'DNI'">
            <b-button
              type="button"
              class="p-2 px-4 btn-xs"
              variant="primary"
              @click="ConsultaDni"
            >
              <span class="align-middle">Reniec</span>
            </b-button>
          </span>
          <span v-if="usuario.tipo === 'RUC'">
            <b-button
              type="button"
              class="p-2 px-4 btn-xs"
              variant="primary"
              @click="ConsultaSunat"
            >
              <span class="align-middle">Sunat</span>
            </b-button>
          </span>
        </b-form-group>
        <b-form-group
          id="input-group-4"
          label="Nombre o Razon Social:"
          label-for="input-2"
          class="col-md-12"
        >
          <b-input class="p-2 px-4 btn-xs" v-model="usuario.nombre"> </b-input>
        </b-form-group>

        <b-form-group
          id="input-group-5"
          label="Direccion"
          label-for="input-1"
          class="col-md-12"
        >
          <b-form-input
            id="Direccion"
            v-model="usuario.direccion"
            class="p-2 px-4 btn-xs"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-6"
          label=""
          label-for="input-1"
          class="col-md-12"
        >
          <b-button
            type="button"
            @click="Guardar()"
            variant="info"
            class="p-2 px-4 btn-xs"
            >Guardar</b-button
          >
        </b-form-group>
      </div>
    </b-card>
    <div>
      <hr />
      <h4>Historial de Facturación</h4>
      <hr />
      <b-card
        class="mt-3"
        header-text-variant="white"
        header-tag="header"
        header-bg-variant="info"
      >
        <div class="form-row">
          <b-table
            id="my-table"
            :items="datosfactura"
            :fields="fields"
            per-page="50"
            small
            class="table table-hover table-sm"
          >
            <template #cell(actions)="row">
              <b-button
                size="sm"
                variant="danger"
                class="mr-1"
                @click="DeleteRecord(row.item.id_facturacion)"
              >
                Eliminar
              </b-button>
            </template>
          </b-table>
        </div>
      </b-card>
    </div>
  </form>
</template>

<script>
import axios from "axios";
//import { mapMutations, mapActions, mapState } from "vuex";
import { mapActions, mapState } from "vuex";
import reniec from "@/assets/reniec_16x16.png";
import sunat from "@/assets/sunat_16x16.png";
export default {
  data() {
    return {
      // imagenes
      imageSunat: sunat,
      imageReniec: reniec,
      modalVisible: false,
      modalTitle: "Título del modal",
      isdelete: true,

      fields: [
        { label: "item", text: "item", key: "id_facturacion", sortable: false },
        { label: "tipo", text: "tipo", key: "tipo", sortable: false },
        { label: "nroDocumento", text: "nroDocumento", key: "nroDocumento" },
        { label: "nombre", text: "nombre", key: "nombre" },
        { label: "direccion", text: "direccion", key: "direccion" },
        { text: "actiones", key: "actions", sortable: false },
      ],
      isLoading: false,
      tipos: [
        { tipo: "RUC", descripcion: "RUC-FACTURA" },
        { tipo: "DNI", descripcion: "DNI-BOLETA DE VENTA" },
      ],
      usuario: {
        id_facturacion: "",
        id_usuario: "",
        tipo: "RUC",
        nroDocumento: "",
        direccion: "",
        nombre: "",
      },
      customersInvoice: [],
    };
  },
  watch: {},
  created() {
    this.cargarlistarpro();
    this.cargarDatosFacturacion();
    this.Cargarfiltrarpro();
  },
  computed: {
    ...mapState(["datosfactura", "filtrodatospro"]),
    id_usuario() {
      return this.$store.state.id_usuario;
    },
    get_datosfactura() {
      return this.datosfactura;
    },
  },
  mounted() {
    //  this.CargarDatos();
    // this.cargarlistarpro();
    // this.cargarDatosFacturacion();
    // this.Cargarfiltrarpro();
  },
  methods: {
    ...mapActions(["actionsdatosfactura", "filtrarpro", "listarpro"]),
    //...mapMutations(["setdatosfactura"]),

    async cargarlistarpro() {
      await this.listarpro();
    },
    async cargarDatosFacturacion() {
      await this.actionsdatosfactura();
    },
    async ConsultaDni() {
      try {
        const me = this;
        //console.log(this.$RutaApiReniec);

        const response = await axios.get(
          this.$RutaApiReniec + "BuscarDni.php?dni=" + me.usuario.nroDocumento
        );

        //console.log(response);

        me.usuario.nombre =
          response.data.nombre +
          " " +
          response.data.primer_apellido +
          " " +
          response.data.segundo_apellido;
        me.usuario.id_usuario = this.id_usuario;
      } catch (error) {
        //console.log(error);
      }
    },
    async ConsultaSunat() {
      try {
        const me = this;
        me.usuario.id_usuario = this.id_usuario;
        const response = await axios.get(
          this.$RutaApiReniec + "BuscarRUC.php?ruc=" + me.usuario.nroDocumento
        );
        //console.log(response.data);
        if (response.data.success) {
          me.usuario.nombre = response.data.nombre_o_razon_social;
          me.usuario.direccion = response.data.direccion;
          //console.log(me.usuario);
        } else {
          me.NoExiste();
        }
      } catch (error) {
        //console.log(error);
      }
    },
    // async cargarsetdatosfactura() {
    //   await this.setdatosfactura(this.datosfactura);
    // },
    async Cargarfiltrarpro() {
      //console.log(this.datosfactura);
      await this.filtrarpro(this.datosfactura);
      //console.log("Me refrescaron", this.filtrodatospro);
    },
    Limpiardatos() {
      this.usuario.nroDocumento = ""; // Limpiar el valor del input
      this.usuario.id_facturacion = ""; // Limpiar el valor del input
      //this.usuario.tipo = ""; // Limpiar el valor del input
      this.usuario.direccion = ""; // Limpiar el valor del input
      this.usuario.nombre = ""; // Limpiar el valor del input
    },

    async Guardar() {
      try {
        //console.log(this);
        let me = this;
        me.usuario.id_usuario = this.id_usuario;
        //console.log(me.usuario);
        await axios.post("ApiWeb/DatosFacturacionGuardar.php", me.usuario);
        await this.cargarDatosFacturacion();
        await this.Cargarfiltrarpro();
        //console.log("Guardado exitosamente");
        this.isdelete = true;
        await this.Limpiardatos();
      } catch (error) {
        console.error("Error al guardar:", error);
      }
    },

    async DeleteRecord(recordId) {
      if (this.isdelete) {
        this.usuario.id_facturacion = recordId;
        this.usuario.id_usuario = this.id_usuario;
        //console.log(this.usuario);

        try {
          const response = await axios.post(
            "ApiWeb/DatosFacturacionDelete.php",
            this.usuario
          );

          if (response.data.error === false) {
            //console.log("Eliminado");
            await this.cargarDatosFacturacion();
            await this.Cargarfiltrarpro();
            this.isdelete = true;
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    makeToast(msg, color) {
      this.toastCount++;
      this.$bvToast.toast(msg, {
        title: "Mensaje Cliente",
        variant: color,
        autoHideDelay: 3000,
        appendToast: false,
      });
    },
  },
};
</script>
<style scoped>
::v-deep .myDiv {
  background-color: #ffffff;
}
.bold-header {
  font-weight: bold; /* Aplica negrita al encabezado */
}
</style>
